import React, { useState, useContext } from "react";
import {
  Fab,
  Typography,
  Grid,
  TextField,
  FormGroup,
  FormControlLabel,
  Checkbox,
} from "@material-ui/core";
import { makeStyles } from "@material-ui/styles";
import useReactRouter from "use-react-router";
import { UserRegisterPublic } from "../../API/Auth";
import { useSnackbar } from "notistack";
import { LangContext } from "../../Context/Langcontext";

const useStyle = makeStyles((theme) => ({
  textfield: {
    "& .MuiInputBase-input": {
      height: "1.5rem",
      fontWeight: 200,
    },
    marginBottom: "1.5rem",
  },
  check: {
    "& .MuiTypography-body1": {
      fontWeight: 400,
    },
  },
}));

const Steptree = ({ setstep, input, setinput }) => {
  const classes = useStyle();
  const { history } = useReactRouter();
  const { enqueueSnackbar } = useSnackbar();
  const langContext = useContext(LangContext);
  const lang = langContext.lang.data;
  const [dis, setdis] = useState(false);

  const [bill, setBill] = useState(true);

  const [state, setstate] = useState({
    first_name: "",
    last_name: "",
    organization: "",
    address: "",
    tambon: "",
    amphoe: "",
    province: "",
    zipcode: "",
    country: "",
    phone: "",
  });
  const [error, setError] = useState({
    statusfname: false,
    first_name: "",
    statuslname: false,
    last_name: "",
    statusphone: false,
    phone: "",
    statusorganization: false,
    organization: "",
    statusaddress: false,
    address: "",
    statusamphoe: false,
    amphoe: "",
    statustambon: false,
    tambon: "",
    statusprovince: false,
    province: "",
    statuscountry: false,
    country: "",
    statuszipcode: false,
    zipcode: "",
  });

  // const [form, setForm] = useState([
  //   { name: "name", title: "Name", require: true, value: "" },
  //   {
  //     name: "lastname",
  //     title: "Lastname",
  //     require: true,
  //     value: "",
  //   },
  //   { name: "phone", title: "Phone", require: false, value: "" },
  //   {
  //     name: "organization",
  //     title: "Organization",
  //     require: false,
  //     value: "",
  //   },
  //   { name: "address", title: "Address", require: false, value: "" },
  //   {
  //     name: "district",
  //     title: "District",
  //     require: false,
  //     value: "",
  //   },
  //   {
  //     name: "subdistrict",
  //     title: "Subdistrict",
  //     require: false,
  //     value: "",
  //   },
  //   { name: "city", title: "City", require: false, value: "" },
  //   { name: "country", title: "Country", require: false, value: "" },
  //   {
  //     name: "zipcode",
  //     title: "Zip Code",
  //     require: false,
  //     value: "",
  //   },
  // ]);

  // const onChange = (e, index) => {
  //   const formvalue = [...form];
  //   formvalue[index].value = e.target.value;
  //   setForm(formvalue);
  // };
  const createUser = async (e) => {
    // const isvalid = validate();
    // if (isvalid) {

    //   // history.replace("/user/login");
    // } else {
    // }
    e.preventDefault();
    if (bill) {
      input.billing_info = {
        first_name: input.first_name,
        last_name: input.last_name,
        organization: input.organization,
        address: input.address,
        tambon: input.tambon,
        amphoe: input.amphoe,
        province: input.province,
        zipcode: input.zipcode,
        country: input.country,
        phone: input.phone,
      };
    } else {
      input.billing_info = state;
    }
    setdis(true);
    const regis = await UserRegisterPublic(input);
    if (regis.status.code === 201) {
      enqueueSnackbar(lang.SignupSuccess, {
        variant: "success",
      });
      setdis(false);
      history.replace("/user/login");
    } else {
      enqueueSnackbar(regis.status.message, {
        variant: "error",
      });
    }
  };

  const handleChange = (e) => {
    setstate({ ...state, [e.target.name]: e.target.value });
  };

  return (
    <div>
      <form onSubmit={createUser}>
        <Grid container spacing={3}>
          <Grid item xs={6}>
            <TextField
              id={`text_firstname`}
              label={lang.Name}
              name="first_name"
              disabled={bill ? true : false}
              required={bill ? false : true}
              fullWidth
              className={classes.textfield}
              value={state.first_name}
              onChange={(e) => {
                handleChange(e);
                setError({ ...error, statusfname: false, first_name: "" });
              }}
              error={error.statusfname}
              helperText={error.first_name}
            />
          </Grid>
          <Grid item xs={6}>
            <TextField
              id={`text_lastname`}
              label={lang.Lastname}
              name="last_name"
              disabled={bill ? true : false}
              required={bill ? false : true}
              fullWidth
              className={classes.textfield}
              value={state.last_name}
              onChange={(e) => {
                handleChange(e);
                setError({ ...error, statuslname: false, last_name: "" });
              }}
              error={error.statuslname}
              helperText={error.last_name}
            />
          </Grid>
          <Grid item xs={6}>
            <TextField
              id={`text_phone`}
              label={lang.Phone}
              name="phone"
              disabled={bill ? true : false}
              required={bill ? false : true}
              fullWidth
              className={classes.textfield}
              value={state.phone}
              onChange={(e) => {
                handleChange(e);
                setError({ ...error, statusphone: false, phone: "" });
              }}
              error={error.statusphone}
              helperText={error.phone}
            />
          </Grid>
          <Grid item xs={6}>
            <TextField
              id={`text_organization`}
              label={lang.Organization}
              name="organization"
              disabled={bill ? true : false}
              required={bill ? false : true}
              fullWidth
              className={classes.textfield}
              value={state.organization}
              onChange={(e) => {
                handleChange(e);
                setError({
                  ...error,
                  statusorganization: false,
                  organization: "",
                });
              }}
              error={error.statusorganization}
              helperText={error.organization}
            />
          </Grid>
          <Grid item xs={6}>
            <TextField
              id={`text_address`}
              label={lang.Address}
              name="address"
              disabled={bill ? true : false}
              required={bill ? false : true}
              fullWidth
              className={classes.textfield}
              value={state.address}
              onChange={(e) => {
                handleChange(e);
                setError({ ...error, statusaddress: false, address: "" });
              }}
              error={error.statusaddress}
              helperText={error.address}
            />
          </Grid>
          <Grid item xs={6}>
            <TextField
              id={`text_amphoe`}
              label={lang.District}
              name="amphoe"
              disabled={bill ? true : false}
              required={bill ? false : true}
              fullWidth
              className={classes.textfield}
              value={state.amphoe}
              onChange={(e) => {
                handleChange(e);
                setError({ ...error, statusamphoe: false, amphoe: "" });
              }}
              error={error.statusamphoe}
              helperText={error.amphoe}
            />
          </Grid>
          <Grid item xs={6}>
            <TextField
              id={`text_tambon`}
              label={lang.Subdistrict}
              name="tambon"
              disabled={bill ? true : false}
              required={bill ? false : true}
              fullWidth
              className={classes.textfield}
              value={state.tambon}
              onChange={(e) => {
                handleChange(e);
                setError({ ...error, statustambon: false, tambon: "" });
              }}
              error={error.statustambon}
              helperText={error.tambon}
            />
          </Grid>
          <Grid item xs={6}>
            <TextField
              id={`text_city`}
              label={lang.City}
              name="province"
              disabled={bill ? true : false}
              required={bill ? false : true}
              fullWidth
              className={classes.textfield}
              value={state.province}
              onChange={(e) => {
                handleChange(e);
                setError({ ...error, statusprovince: false, province: "" });
              }}
              error={error.statusprovince}
              helperText={error.province}
            />
          </Grid>
          <Grid item xs={6}>
            <TextField
              id={`text_country`}
              label={lang.Country}
              name="country"
              disabled={bill ? true : false}
              required={bill ? false : true}
              fullWidth
              className={classes.textfield}
              value={state.country}
              onChange={(e) => {
                handleChange(e);
                setError({ ...error, statuscountry: false, country: "" });
              }}
              error={error.statuscountry}
              helperText={error.country}
            />
          </Grid>
          <Grid item xs={6}>
            <TextField
              id={`text_zipcode`}
              label={lang.Zipcode}
              name="zipcode"
              disabled={bill ? true : false}
              required={bill ? false : true}
              fullWidth
              className={classes.textfield}
              value={state.zipcode}
              onChange={(e) => {
                handleChange(e);
                setError({ ...error, statuszipcode: false, zipcode: "" });
              }}
              error={error.statuszipcode}
              helperText={error.zipcode}
            />
          </Grid>
        </Grid>

        <div>
          <FormGroup>
            <FormControlLabel
              className={classes.check}
              control={<Checkbox name="check" style={{ color: "#E16733" }} />}
              label={lang.UsePersonalInformation}
              checked={bill}
              style={{ marginBottom: "1rem" }}
              onChange={() => {
                setBill(!bill);
              }}
            />
          </FormGroup>
        </div>
        <div style={{ display: "flex", justifyContent: "space-between" }}>
          <Fab
            variant="extended"
            aria-label="signin"
            color="secondary"
            style={{ boxShadow: "unset" }}
            onClick={() => {
              setstep(1);
            }}
          >
            <Typography variant="h6" component="p" style={{ color: "white" }}>
              {lang.Back}
            </Typography>
          </Fab>

          <Fab
            variant="extended"
            aria-label="signin"
            color="primary"
            type="submit"
            disabled={dis}
            style={{ boxShadow: "unset" }}
            // onClick={() => {
            //   createUser();
            // }}
          >
            <Typography variant="h6" component="p" style={{ color: "white" }}>
              {lang.Finish}
            </Typography>
          </Fab>
        </div>
      </form>
    </div>
  );
};

export default Steptree;
